module.exports = __webpack_public_path__ + "media/images/light_gray_round_edges-bfddb2883ac36c08af67e1b402e45701.svg";